export enum VisualizationElementId {
    Voxel = 0,
    Point = 2,
    Quad = 4,
    Box = 7,
    FlatVoxel = 8,
}
